import React from 'react';
import { ManifoldsDiagramPdf } from '../features/pdf/ManifoldsDiagramPdf';
import { RouteComponentProps } from '../helpers/RouteComponentProps';
import { PageContainer } from '../layout/Layout';
import { Alert } from '../shared/Alert';

type Props = RouteComponentProps<{ projectId: string; designId: string; unitId: string }>;

export const PdfRoute = ({ projectId, designId, unitId }: Props) => {
  if (!projectId || !designId || !unitId) {
    return (
      <PageContainer>
        <Alert
          type="error"
          title="Invalid Parameters"
          body="Project ID, Design ID and Unit ID must all be supplied"
          data-testid="pdf-error-box"
        />
      </PageContainer>
    );
  }

  const unitNumber = parseInt(unitId, 10);

  if (Number.isNaN(unitNumber)) {
    return (
      <PageContainer>
        <Alert type="error" title="Invalid Unit" body="Invalid Unit ID" data-testid="pdf-error-box" />
      </PageContainer>
    );
  }

  return <ManifoldsDiagramPdf projectId={projectId} designId={designId} unitId={unitNumber} />;
};
